import { useMemo } from 'react';
import { Typography, Card, Row, Col, Spin, Statistic } from 'antd';
import { TeamOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const UserMetrics = ({ data, loading, currentDateInfo }) => {
  const metrics = data || {};

  const activeClients = useMemo(() => {
    const clients = (metrics.active_users_by_role || []).find(r => r.role_code === 4);
    return clients ? clients.count : 0;
  }, [metrics]);

  const activeSuppliers = useMemo(() => {
    const suppliers = (metrics.active_users_by_role || []).find(r => r.role_code === 6);
    return suppliers ? suppliers.count : 0;
  }, [metrics]);

  const userRoleData = useMemo(() => {
    if (!metrics.active_users_by_role || metrics.active_users_by_role.length === 0) {
      return [];
    }

    return metrics.active_users_by_role.map(role => ({
      name: role.role_name,
      value: role.count,
      fullMark: Math.max(...metrics.active_users_by_role.map(r => r.count))
    }));
  }, [metrics.active_users_by_role]);

  const usersByRole = metrics.users_by_role || [];

  return (
    <Card className="dashboard-card">
      <div className="card-header">
        <div className="card-icon card-icon-green">
          <TeamOutlined />
        </div>
        <div>
          <Title level={4}>Resumen de Usuarios</Title>
          <Text type="secondary">{currentDateInfo || "Base de usuarios activa"}</Text>
        </div>
      </div>
      <div className="card-content">
        {loading ? (
          <Spin />
        ) : (
          <>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Statistic
                  title="Usuarios Totales"
                  value={metrics.total_users || 0}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Col>
              <Col span={12}>
                <Statistic
                  title="Usuarios Activos"
                  value={metrics.total_active_users || 0}
                  valueStyle={{ color: '#52c41a' }}
                />
              </Col>
              <Col span={12}>
                <Statistic
                  title="Clientes Activos"
                  value={activeClients}
                  valueStyle={{ color: '#722ed1' }}
                />
              </Col>
              <Col span={12}>
                <Statistic
                  title="Proveedores Activos"
                  value={activeSuppliers}
                  valueStyle={{ color: '#fa8c16' }}
                />
              </Col>
            </Row>

            {usersByRole.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <Text strong>Desglose por Rol:</Text>
                <div style={{ marginTop: 8 }}>
                  <Row gutter={[8, 8]}>
                    {usersByRole.map((role, index) => (
                      <Col span={8} key={index}>
                        <div style={{
                          padding: '8px',
                          background: '#f8f9fa',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef',
                          textAlign: 'center'
                        }}>
                          <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px' }}>
                            {role.role_name}
                          </div>
                          <div style={{ fontSize: '16px', fontWeight: '600', color: '#1890ff' }}>
                            {role.count}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default UserMetrics;